import React, {ReactElement, useState} from 'react';
import {IElementStatusComponent} from '../../../incase-domain/elements/statusComponent';
import Animated from './animated/animated';
import INcaseLogo from '../../../../assets/images/ui/incase-logo-black.svg';

interface ElementStatusComponentProps {
    element: IElementStatusComponent;
}
function ElementStatusComponent(props: ElementStatusComponentProps): ReactElement {
    const {element} = props;
    const [clickedParts, setClickedParts] = useState([] as number[]);

    const mainImageWidthHeightRatio = element.mainImageWidthHeightRatio || 1;

    function handleClickPart(partIndex: number): void {
        if (clickedParts.includes(partIndex)) {
            setClickedParts(clickedParts.filter((el) => el !== partIndex));
        } else {
            setClickedParts([...clickedParts, partIndex]);
        }
    }

    function elementParts(
        parts: {
            text: string;
            image: string;
            tempIndex: number;
        }[]
    ): JSX.Element {
        return (
            <div className="u-flex u-flex-col  u-h-evenly" style={{width: '50%'}}>
                {(parts || []).map((part, index) => {
                    return (
                        <div className="u-flex" key={part.toString() + index}>
                            <div
                                style={{width: '25%', maxWidth: '100%', margin: '0.25em'}}
                                onClick={() => {
                                    handleClickPart(part.tempIndex);
                                }}
                            >
                                <img style={{objectFit: 'contain'}} src={part.image || INcaseLogo} alt="" />
                            </div>

                            <Animated
                                animationIn="bounceInRight"
                                style={{fontSize: `${element.font.size || 2}em`, objectFit: 'contain', width: '50%', margin: '0.25em'}}
                                isVisible={part.tempIndex >= 0 && clickedParts.includes(part.tempIndex)}
                            >
                                {part.text}
                            </Animated>
                        </div>
                    );
                })}
            </div>
        );
    }

    const tempParts = element.statusParts.map((part, partIndex) => {
        return {...part, tempIndex: partIndex};
    });

    if (element.statusLayout === 0) {
        const center = tempParts && tempParts.length > 0 ? Math.floor(tempParts.length / 2) : 0;

        const leftParts = tempParts.slice(0, center);
        const rightParts = tempParts.slice(center, tempParts.length);

        return (
            <div className="u-flex">
                {elementParts(leftParts)}
                <img
                    style={{
                        width: '50%',
                        maxWidth: '100%',
                        objectFit: 'contain',
                        height: `${100 * mainImageWidthHeightRatio}%`,
                    }}
                    src={element.statusMainImage}
                    alt=""
                />
                {elementParts(rightParts)}
            </div>
        );
    }
    if (element.statusLayout === 1) {
        return (
            <div className="u-flex">
                <img
                    style={{
                        width: '50%',
                        maxWidth: '100%',
                        objectFit: 'contain',
                        height: `${100 * mainImageWidthHeightRatio}%`,
                    }}
                    src={element.statusMainImage}
                    alt=""
                />
                {elementParts(tempParts)}
            </div>
        );
    }
    if (element.statusLayout === 2) {
        return (
            <div className="u-flex">
                {elementParts(tempParts)}
                <img
                    style={{
                        width: '50%',
                        maxWidth: '100%',
                        objectFit: 'contain',
                        height: `${100 * mainImageWidthHeightRatio}%`,
                    }}
                    src={element.statusMainImage}
                    alt=""
                />
            </div>
        );
    }

    return (
        <div>
            <img
                style={{
                    width: '50%',
                    maxWidth: '100%',
                    objectFit: 'contain',
                    height: `${100 * mainImageWidthHeightRatio}%`,
                }}
                src={element.statusMainImage}
                alt="Status element main"
            />
        </div>
    );
}

export default ElementStatusComponent;
